module.exports = __webpack_public_path__ + "static/media/YF23_5.c1e8c77f.jpg";